import { connect } from 'react-redux';

import { fetchEventEmailsLog } from 'api/mails/mails.actions';
import { createModalOpenAction } from 'actions/modalActions';
import { SimpleModalId } from 'constants/modalId';
import { EmailsLogTable } from './EmailsLogTable';

const mapDispatchToProps = (dispatch: Function) => ({
  fetchEmailsLog: (eventId: string) => dispatch(fetchEventEmailsLog(eventId)),
  openDetails: (data: any) => dispatch(createModalOpenAction(SimpleModalId.LogDetails, data)),
});

export const EmailsLogTableContainer = connect(null, mapDispatchToProps)(EmailsLogTable);
